module.exports = __webpack_public_path__ + "assets/img/filter.4da600d1.svg";